// solace — theme.js — sticky buy bar, variant switching, cart cross-sell, accordions, a11y
document.addEventListener('DOMContentLoaded', function(){
  // Mobile nav
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  const closeBtn = document.querySelector('[data-mobile-close]');
  if(toggle && nav){
    toggle.addEventListener('click', ()=> nav.classList.add('is-open'));
    if(closeBtn) closeBtn.addEventListener('click', ()=> nav.classList.remove('is-open'));
    nav.addEventListener('click', (e)=>{ if(e.target===nav) nav.classList.remove('is-open'); });
  }

  // Accordions
  document.querySelectorAll('.accordion__head').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const acc = btn.closest('.accordion');
      const isOpen = acc.classList.contains('is-open');
      document.querySelectorAll('.accordion').forEach(a=>a.classList.remove('is-open'));
      if(!isOpen) acc.classList.add('is-open');
      btn.setAttribute('aria-expanded', !isOpen);
    });
  });

  // PDP variant switching
  const pdp = document.querySelector('[data-pdp]');
  if(pdp){
    const form = pdp.querySelector('form[data-product-form]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const priceEl = pdp.querySelector('[data-pdp-price]');
    const compareEl = pdp.querySelector('[data-pdp-compare]');
    const discountEl = pdp.querySelector('[data-pdp-discount]');
    const skuEl = pdp.querySelector('[data-pdp-sku]');
    const mainImg = pdp.querySelector('[data-pdp-main-img]');
    const stickyImg = document.querySelector('[data-sticky-img]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const variantDataEl = document.getElementById('variant-data');
    let variants = [];
    try{ variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : []; }catch(e){}
    
    function formatMoney(cents){
      return '£' + (cents/100).toFixed(2).replace(/\.00$/,'');
    }
    function updateVariant(variant){
      if(!variant) return;
      if(idInput) idInput.value = variant.id;
      // sticky buy form input too
      const stickyInput = document.querySelector('[data-sticky-variant-input]');
      if(stickyInput) stickyInput.value = variant.id;
      if(priceEl) priceEl.textContent = formatMoney(variant.price);
      const stickyPriceEl = document.querySelector('[data-sticky-price]');
      if(stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if(compareEl){
        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display='';
          if(discountEl){
            const pct = Math.round((1 - variant.price/variant.compare_at_price)*100);
            discountEl.textContent = '−' + pct + '%';
            discountEl.style.display='';
          }
        }else{
          compareEl.style.display='none';
          if(discountEl) discountEl.style.display='none';
        }
      }
      if(skuEl && variant.sku) skuEl.textContent = variant.sku;
      if(mainImg && variant.featured_image){
        mainImg.src = variant.featured_image.src || variant.featured_image;
      }
      if(stickyImg && variant.featured_image){
        stickyImg.src = variant.featured_image.src || variant.featured_image;
      }
      // update URL without reload
      if(variant.id){
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      // availability
      const addBtn = form ? form.querySelector('[type="submit"]') : null;
      const stickyBtn = document.querySelector('[data-sticky-submit]');
      const available = variant.available;
      if(addBtn){
        addBtn.disabled = !available;
        addBtn.innerHTML = available ? 'Add to basket — ' + formatMoney(variant.price) : 'Sold out';
      }
      if(stickyBtn){
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? 'Add — ' + formatMoney(variant.price) : 'Sold out';
      }
    }

    // pill click
    pdp.querySelectorAll('[data-variant-pill]').forEach(pill=>{
      pill.addEventListener('click', ()=>{
        pdp.querySelectorAll('[data-variant-pill]').forEach(p=>p.classList.remove('is-selected'));
        pill.classList.add('is-selected');
        const vid = pill.getAttribute('data-variant-id');
        const variant = variants.find(v=> String(v.id)===String(vid));
        if(variant) updateVariant(variant);
        // update hidden select for accessibility
        const sel = pdp.querySelector('[data-variant-select]');
        if(sel) sel.value = vid;
      });
    });
    // select fallback
    const sel = pdp.querySelector('[data-variant-select]');
    if(sel){
      sel.addEventListener('change', ()=>{
        const variant = variants.find(v=> String(v.id)===String(sel.value));
        if(variant){
          pdp.querySelectorAll('[data-variant-pill]').forEach(p=>p.classList.toggle('is-selected', String(p.getAttribute('data-variant-id'))===String(variant.id)));
          updateVariant(variant);
        }
      });
    }
    // thumbs
    pdp.querySelectorAll('[data-thumb]').forEach(thumb=>{
      thumb.addEventListener('click', ()=>{
        pdp.querySelectorAll('[data-thumb]').forEach(t=>t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-src');
        if(src && mainImg) mainImg.src = src;
      });
    });
  }

  // Sticky mobile buy bar — visibility + fires real product form, respects selected variant
  const stickyBar = document.querySelector('[data-sticky-buy]');
  const productForm = document.querySelector('form[data-product-form]');
  if(stickyBar && productForm){
    const sentinel = document.querySelector('[data-sticky-sentinel]');
    const stickySubmit = stickyBar.querySelector('[data-sticky-submit]');
    // observe hero/pdp price to toggle
    if('IntersectionObserver' in window && sentinel){
      const io = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            stickyBar.classList.remove('is-visible');
          }else{
            stickyBar.classList.add('is-visible');
          }
        });
      }, {threshold:0});
      io.observe(sentinel);
    }else{
      window.addEventListener('scroll', ()=>{
        if(window.scrollY > 600) stickyBar.classList.add('is-visible');
        else stickyBar.classList.remove('is-visible');
      }, {passive:true});
    }
    if(stickySubmit){
      stickySubmit.addEventListener('click', (e)=>{
        e.preventDefault();
        // respect selected variant: sticky input already synced via PDP logic
        // if form has id input, ensure it matches sticky variant input
        const stickyVariantInput = stickyBar.querySelector('[data-sticky-variant-input]');
        const mainVariantInput = productForm.querySelector('input[name="id"]');
        if(stickyVariantInput && mainVariantInput){
          mainVariantInput.value = stickyVariantInput.value;
        }
        // fire real product form submit
        if(productForm.requestSubmit) productForm.requestSubmit();
        else productForm.submit();
      });
    }
  }

  // Cart quantity
  document.querySelectorAll('[data-qty-minus]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const input = btn.parentElement.querySelector('input');
      if(!input) return;
      let v = parseInt(input.value,10)||1;
      if(v>1){ input.value = v-1; input.dispatchEvent(new Event('change',{bubbles:true})); }
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const input = btn.parentElement.querySelector('input');
      if(!input) return;
      let v = parseInt(input.value,10)||1;
      input.value = v+1; input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  // Cart cross-sell auto-hide once in basket
  // The cross-sell is its OWN standalone form with id="cross-sell-form" and button form="cross-sell-form" — never nested
  const crossSell = document.querySelector('[data-cross-sell]');
  if(crossSell){
    const handle = crossSell.getAttribute('data-cross-sell-handle');
    // if cart contains handle, hide
    const cartHandles = (crossSell.getAttribute('data-cart-handles')||'').split(',').map(s=>s.trim());
    if(handle && cartHandles.includes(handle)){
      crossSell.style.display='none';
    }
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click', (e)=>{
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
});
